import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const GET_SUPPORTED_DOCUMENTS_REQUEST = 'GET_SUPPORTED_DOCUMENTS_REQUEST'
export const GET_SUPPORTED_DOCUMENTS_SUCCESS = 'GET_SUPPORTED_DOCUMENTS_SUCCESS'
export const GET_SUPPORTED_DOCUMENTS_FAILURE = 'GET_SUPPORTED_DOCUMENTS_FAILURE'

export const GET_CLIENT_SUPPORTED_DOCUMENTS_REQUEST = 'GET_CLIENT_SUPPORTED_DOCUMENTS_REQUEST'
export const GET_CLIENT_SUPPORTED_DOCUMENTS_SUCCESS = 'GET_CLIENT_SUPPORTED_DOCUMENTS_SUCCESS'
export const GET_CLIENT_SUPPORTED_DOCUMENTS_FAILURE = 'GET_CLIENT_SUPPORTED_DOCUMENTS_FAILURE'

export const GET_GENERIC_TYPE_DOCUMENTS_REQUEST = 'GET_GENERIC_TYPE_DOCUMENTS_REQUEST'
export const GET_GENERIC_TYPE_DOCUMENTS_SUCCESS = 'GET_GENERIC_TYPE_DOCUMENTS_SUCCESS'
export const GET_GENERIC_TYPE_DOCUMENTS_FAILURE = 'GET_GENERIC_TYPE_DOCUMENTS_FAILURE'

export const fetchSupportedDocuments = (limit = 100, offset = 0, search = '') => ({
  [CALL_API]: {
    endpoint: `/api/master-document/supported-documents/?limit=${limit}&offset=${offset}${
      search ? '&search=' + search : ''
    }`,
    types: [GET_SUPPORTED_DOCUMENTS_REQUEST, GET_SUPPORTED_DOCUMENTS_SUCCESS, GET_SUPPORTED_DOCUMENTS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
export const fetchClientSupportedDocuments = () => ({
  [CALL_API]: {
    endpoint: `/api/master-document/client-support-documents`,
    types: [
      GET_CLIENT_SUPPORTED_DOCUMENTS_REQUEST,
      GET_CLIENT_SUPPORTED_DOCUMENTS_SUCCESS,
      GET_CLIENT_SUPPORTED_DOCUMENTS_FAILURE,
    ],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const fetchGenericTypeDocuments = () => ({
  [CALL_API]: {
    endpoint: `/api/master-document/supported-documents/?generic=true`,
    types: [GET_GENERIC_TYPE_DOCUMENTS_REQUEST, GET_GENERIC_TYPE_DOCUMENTS_SUCCESS, GET_GENERIC_TYPE_DOCUMENTS_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
